import { Component, Inject, OnInit } from '@angular/core';
import { CardAttendance } from '../card-attendance';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../../../../../../shared-modules/login/login.service';
@Component({
    selector: 'app-attendance-card-modal',
    templateUrl: './attendance-card-modal.component.html',
    styleUrls: ['./attendance-card-modal.component.css']
})
export class AttendanceCardModalComponent implements OnInit {
    studentAttendance: CardAttendance[] = [];
    displayedColumns: string[] = ['Class', 'Meets', 'Marked'];
    yearToDateTardyCount = 0;
    yearToDateAbsentCount = 0;
    DaysPresent = 0;
    TotalDays = 0;
    HoursPresent = 0;
    TotalHours = 0;
    dailyAttendance: boolean = false;
    v10: boolean;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private dialogRef: MatDialogRef<AttendanceCardModalComponent>, private loginService: LoginService) { }

    ngOnInit() {
        this.v10 = this.loginService.LoginSettings.V10;
        this.dailyAttendance = this.loginService.LoginSettings.ViewDailyAttendance;
        this.studentAttendance = this.data.studentAttendance;
        this.yearToDateAbsentCount = this.data.totalAbsences;
        this.yearToDateTardyCount = this.data.totalTardies;
        if (!this.v10) {
            this.DaysPresent = this.data.DaysPresent;
            this.TotalDays = this.data.TotalDays;
            this.HoursPresent = this.data.HoursPresent;
            this.TotalHours = this.data.TotalHours;
        }
    }

    viewAllClick() {
        this.router.navigateByUrl('/student360/attendance');
        this.dialogRef.close();
    }

    closeClick() {
        this.dialogRef.close();
    }

}
